import { Component, OnInit } from '@angular/core';
import { Router, ResolveStart } from '@angular/router';
import { filter, map } from "rxjs/operators";
import { TeamSeasonService } from 'src/app/services/team-season.service';
import { MemberService } from 'src/app/services/member.service';
import { GalleryService } from 'src/app/services/gallery.service';
import { EventService } from 'src/app/services/event.service';
import { TeamService } from 'src/app/services/team.service';

@Component({
  selector: 'breadcrumbs',
  templateUrl: 'breadcrumbs.html',
  styleUrls: ["breadcrumbs.css"],
})

export class BreadcrumbsComponent implements OnInit {
  routes: any[];

  constructor(
    private readonly router: Router,
    private readonly teamSeaonsService: TeamSeasonService,
    private readonly memberService: MemberService,
    private readonly galleryService: GalleryService,
    private readonly eventService: EventService,
    private readonly teamService: TeamService) { }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof ResolveStart),
      map(event => {
        let route = event['state'].root;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
    ).subscribe(mainRoot => {
      this.routes = [];
      mainRoot.data.routes.forEach(route => {
        if (route.routerLink.includes(":id")) {
          let newRoute: any = { title: undefined, routerLink: undefined };
          let id: string = mainRoot.params.id;
          newRoute.routerLink = route.routerLink.replace(":id", id);

          switch (mainRoot.component.name) {
            case "MemberDetailViewComponent":
              this.memberService.getMembers().subscribe(members => {
                let member = members.find(member => member.memberId === id);
                newRoute.title = `${member.firstname} ${member.lastname}`;
              });
              break;
            case "TeamComponent":
              this.teamSeaonsService.getTeamSeasons().subscribe(teamSeasons => {
                this.teamService.getTeams().subscribe(teams => {
                  newRoute.title = teams.find(team => team.teamId === teamSeasons.find(teamSeason => teamSeason.teamSeasonId === id).teamId).name
                })
              })
              break;
            case "GalleryComponent":
              this.galleryService.getGalleries().subscribe(galleries => {
                newRoute.title = galleries.find(gallery => gallery.galleryId === id).title;
              });
              break;
            case "EventReportComponent":
              this.eventService.getEvents().subscribe(events => {
                newRoute.title = events.find(event => event.eventId === id).title;
              });
              break;
          }
          this.routes.push(newRoute);
        } else {
          this.routes.push(route);
        }
      });
    });
  }
}
